// import qs from 'qs';
import request from './request';

// 根据类型查询banner列表
export const getBannerList = params =>
  request({
    url: '/generic/banner/list',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: params,
    // data: qs.stringify(params),
    // transformRequest: [data => data] // 避免 axios 自动转换请求体
  });
